import { Stack } from "@mui/material";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";

const DateRangePickerV2 = ({ value, onChange, error }) => {
  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <Stack spacing={2} direction="row">
        <DatePicker
          label="Từ ngày"
          value={value?.from}
          onChange={(newValue) =>
            onChange({
              from: newValue,
              to: value?.to,
            })
          }
          format={"dd-MM-yyyy"}
          disableFuture
          slotProps={{
            textField: {
              error: !!error?.from,
              helperText: error?.from,
            },
          }}
        />
        <DatePicker
          label="Đến ngày"
          value={value?.to}
          onChange={(newValue) =>
            onChange({
              from: value?.from,
              to: newValue,
            })
          }
          format={"dd-MM-yyyy"}
          minDate={value?.from}
          disableFuture
          slotProps={{
            textField: {
              error: !!error?.to,
              helperText: error?.to,
            },
          }}
        />
      </Stack>
    </LocalizationProvider>
  );
};

export default DateRangePickerV2;
